import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "ApiClient";
import { ApiURL } from "utils/Actions";
import { API_RESPONSE_STATUS } from "utils/Constants";
import { showErrorModal } from "utils/hooks/handleNotification";
import { SchoolContactTableType } from "utils/Types";
import { common } from "utils/Wording";

type CredentialSliceType = {
  raters: Array<SchoolContactTableType>;
  isLoading: boolean;
  isLoadingError: boolean;
};

const CredentialInit: CredentialSliceType = {
  raters: [] as CredentialSliceType["raters"],
  isLoading: false,
  isLoadingError: false
};

export const fetchRaters = createAsyncThunk("/credentials", async () => {
  try {
    const res = await api.get(ApiURL.getStaffList);
    if (res?.data?.status === API_RESPONSE_STATUS.ERROR) {
      throw new Error(common.loadingError);
    }
    return res?.data?.data ? res.data.data : [];
  } catch (error: any) {
    console.error(error);
    showErrorModal({
      title: common.failAsync,
      errors: error.response?.data?.errors ? error.response.data.errors : [error.message]
    });
    return CredentialInit.raters;
  }
});

export const CredentialsSlice = createSlice({
  name: "credentials",
  initialState: CredentialInit,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchRaters.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(fetchRaters.fulfilled, (state, action) => {
      return {
        ...state,
        raters: action.payload && action.payload,
        isLoading: false
      };
    });
    builder.addCase(fetchRaters.rejected, () => {
      return CredentialInit;
    });
  }
});

export default CredentialsSlice.reducer;
